<template>
  <article class="itineraryFooter">
    <div class="itineraryFooter__fare">
      <span class="itineraryFooter__fareLabel"> {{ $t('from') }} </span>
      <span class="itineraryFooter__farePrice">
        <span class="itineraryFooter__totalAmount">
          {{
            fare?.fare_information?.segment_price ||
            $parent.journey.minimum_price.total | amountFormatPipe
          }}
        </span>
        <span class="itineraryFooter__totalCurrency">
          {{ $parent.journey.minimum_price.currency }}
        </span>
      </span>
      <button class="itineraryFooter__displayFares">
        <i class="fas fa-angle-down"></i>
      </button>
      <!-- <div class="itineraryFooter__group"></div> -->
    </div>
  </article>
</template>

<script>
import filters from '../../helpers/filters'
export default {
  name: 'ItineraryFooter',
  mixins: [filters],
  props: {
    fare: {},
  },
}
</script>

<style lang="sass">
.itineraryFooter
  display: flex
  align-items: flex-end
  padding: 0 .75rem .5rem
  justify-content: space-between
  border-top: 1px solid var(--color-overlay-10)
  padding-top: 0.5rem
  background: var(--color-background)
.itineraryFooter__fare
  display: flex
  height: 100%
  gap: 1rem
  width: 100%
  align-items: center
  justify-content: end
.itineraryFooter__farePrice
  color: var(--color-primary)
  font-size: var(--font-size-lg)
  font-weight: 600
  text-align: right
.itineraryFooter__fareLabel
  font-weight: bold
  font-size: var(--font-size-sm)
  text-align: right
  color: var(--color-primary)
  line-height: 1.375rem
  align-self: flex-end
  padding-bottom: .25rem
.itineraryFooter__totalCurrency
  margin-right: .5rem
  font-size: var(--font-size-md)
  font-weight: 700
.itineraryFooter__flightType
  font-weight: bold
  text-decoration: underline
  font-size: var(--font-size-sm)
  color: var(--color-primary)
  margin-left: .5rem
.itineraryFooter__displayFares
  all: unset
  cursor: pointer
  flex-grow: 1
  text-align: end
@media (min-width: 1024px)
  .itineraryFooter
    padding-right: 1.5rem
    align-items: center
    justify-content: space-between
    border: 0
    position: relative
    flex-direction: column
    &:after
      content: ''
      width: 100%
      height: 100%
      position: absolute
      top: 0
      right: 0
      background: #EEF1F7
      opacity: .1
      transition: opacity .2s ease
  .itineraryFooter__farePrice
    font-size: var(--font-size-xl)
  .itineraryFooter__group
    justify-content: flex-end
    display: flex
    order: 3
  .itineraryFooter__fareLabel,
  .itineraryFooter__displayFares
    display: none
@media (min-width: 1200px)
  .itineraryFooter
    padding-right: 1rem
    min-width: 220px
</style>
